import { generateClient } from "aws-amplify/api";
import { getBglData, getBglDetails } from "../graphql/queries";

const client = generateClient();

const bglService = {
  getUserBglData: async (operation, parameters) => {
    console.log(
      "[BGL] Requesting BGL data for " +
        operation +
        " with the following parameters:"
    );
    console.log(JSON.stringify(parameters));
    const response = await client.graphql({
      query: getBglData,
      variables: { operation, parameters: JSON.stringify(parameters) },
      authMode: "userPool",
    });
    console.log("Response for " + operation, response.data.getBglData);
    return response.data.getBglData;
  },
  getBglDetails: async () => {
    const response = await client.graphql({
      query: getBglDetails,
      variables: {},
      authMode: "iam",
    });
    return JSON.parse(response.data.getBglDetails) || [];
  },
  getBglDetailsUP: async () => {
    const response = await client.graphql({
      query: getBglDetails,
      variables: {},
      authMode: "userPool",
    });
    return JSON.parse(response.data.getBglDetails) || [];
  },
};

export default bglService;
